import React, { PureComponent } from "react";
import { Field, reduxForm } from "redux-form";
import PropTypes from "prop-types";
import i18n from "i18next";

import { FormDropDown, FormTextArea } from "../Common";
import { required } from "../../helpers/FormField/formFieldHelpers";
import Button from "../Common/Button";

class ContactUsForm extends PureComponent {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    onGoBack: PropTypes.func.isRequired
  };

  getMessageTypeOptions = () => [
    { value: "report", label: i18n.t("contactUs.reportAnIssue") },
    { value: "question", label: i18n.t("contactUs.questionOrder") },
    { value: "comment", label: i18n.t("contactUs.commentSuggestion") }
  ];

  render() {
    const { onGoBack, handleSubmit } = this.props;

    return (
      <form className="form__container" onSubmit={handleSubmit}>
        <div className="form__row">
          <Field
            component={FormDropDown}
            data={this.getMessageTypeOptions()}
            name="messageType"
            valueContainerLabel={i18n.t("contactUs.messageType")}
            selectClassName="--max"
            validate={[required]}
          />
        </div>
        <div className="form__row">
          <Field component={FormTextArea} name="message" textAreaClassName="--max" validate={[required]} maxLength={1000} />
        </div>
        <div className="form__row --centered">
          <Button className="form__button --cancel" label={i18n.t("button.cancel")} onClick={onGoBack} type="button" />
          <Button className="form__button" label={i18n.t("contactUs.send")} />
        </div>
      </form>
    );
  }
}

export default reduxForm({ form: "contact-us-form" })(ContactUsForm);



// WEBPACK FOOTER //
// ./src/components/ContactUs/ContactUsForm.js